export const ONLY_LETTERS = /[^áâãéêíîóôõúûÁÂÃÉÊÍÎÓÔÕÚÛa-z ]/gi;

export function countWords(text: string) {
  return text?.match(/\w+/g)?.length || 0;
}
